/* ============================================================
   KIASA ROI Calculator — Logic
   assets/kiasa-calculator.js
   Pure vanilla JS — zero frameworks
   ============================================================ */

(function () {
  'use strict';

  /* ── Constants ── */
  var STEP_PCTS   = { 1: '25%',       2: '50%',       3: '75%',       4: '100%' };
  var STEP_LABELS = { 1: 'STEP 1 OF 4', 2: 'STEP 2 OF 4', 3: 'STEP 3 OF 4', 4: 'STEP 4 OF 4' };

  /* ── Logo preloader — loads an image URL into a canvas, returns base64 + dimensions ── */
  function loadImage(url, callback) {
    if (!url) { callback(null); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var canvas = document.createElement('canvas');
        canvas.width  = img.naturalWidth;
        canvas.height = img.naturalHeight;
        canvas.getContext('2d').drawImage(img, 0, 0);
        callback({ src: canvas.toDataURL('image/png'), w: img.naturalWidth, h: img.naturalHeight });
      } catch (e) {
        callback(null); /* CORS or tainted canvas */
      }
    };
    img.onerror = function () { callback(null); };
    img.src = url;
  }

  /* ── Bootstrap every calculator instance on the page ── */
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var wrappers = document.querySelectorAll('[data-kiasa-calc]');
    wrappers.forEach(initCalc);
  });

  /* ================================================================
     initCalc — scoped entirely to one section wrapper
     ================================================================ */
  function initCalc(wrapper) {

    /* ── Read schema data attributes ── */
    var currency       = wrapper.dataset.currency       || '£';
    var costPerSqm     = parseFloat(wrapper.dataset.costPerSqm)    || 165;
    var costPerSqmMax  = parseFloat(wrapper.dataset.costPerSqmMax) || costPerSqm;
    var publicKey   = wrapper.dataset.publicKey   || '';
    var serviceId   = wrapper.dataset.serviceId   || '';
    var templateId  = wrapper.dataset.templateId  || '';
    var teamEmail   = wrapper.dataset.teamEmail   || '';
    var logoUrl     = wrapper.dataset.logoUrl     || '';

    /* ── Preload logo for PDF (async, fires before user reaches Step 4) ── */
    var logoCache = null;
    loadImage(logoUrl, function (result) { logoCache = result; });

    /* ── Internal state ── */
    var currentStep  = 1;
    var selectedRole = '';
    var results      = {};

    /* ── DOM refs ── */
    var progressFill  = wrapper.querySelector('[data-progress-fill]');
    var stepLabelEl   = wrapper.querySelector('[data-step-label]');
    var stepPctEl     = wrapper.querySelector('[data-step-pct]');
    var areaDisplay   = wrapper.querySelector('[data-area-display]');
    var emailSuccess  = wrapper.querySelector('[data-email-success]');
    var pills         = wrapper.querySelectorAll('.kiasa-roi-pill');
    var pillsError    = wrapper.querySelector('[data-error="role"]');

    /* ── Initialise EmailJS if credentials present ── */
    if (publicKey && window.emailjs) {
      try { window.emailjs.init(publicKey); } catch (e) {}
    }

    /* ─────────────────────────────────────────────
       LIVE AREA CALCULATION
    ───────────────────────────────────────────── */
    var lengthInput = wrapper.querySelector('[data-field="length"]');
    var widthInput  = wrapper.querySelector('[data-field="width"]');

    function updateArea() {
      var l = parseFloat(lengthInput ? lengthInput.value : '');
      var w = parseFloat(widthInput  ? widthInput.value  : '');
      if (l > 0 && w > 0) {
        var area = (l * w).toFixed(1);
        areaDisplay.textContent = 'Total area: ' + area + ' m\u00b2';
        areaDisplay.classList.add('has-value');
      } else {
        areaDisplay.textContent = 'Total area: \u2014 m\u00b2';
        areaDisplay.classList.remove('has-value');
      }
    }

    if (lengthInput) lengthInput.addEventListener('input', updateArea);
    if (widthInput)  widthInput.addEventListener('input', updateArea);

    /* ─────────────────────────────────────────────
       ROLE PILLS
    ───────────────────────────────────────────── */
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        selectedRole = pill.dataset.role;
        if (pillsError) pillsError.classList.remove('is-visible');
      });
    });

    /* ─────────────────────────────────────────────
       STEP NAVIGATION
    ───────────────────────────────────────────── */
    function showStep(n) {
      wrapper.querySelectorAll('.kiasa-roi-step').forEach(function (el) {
        el.classList.remove('is-active');
      });
      var target = wrapper.querySelector('[data-step="' + n + '"]');
      if (target) target.classList.add('is-active');

      currentStep = n;
      if (progressFill) progressFill.style.width = STEP_PCTS[n];
      if (stepLabelEl)  stepLabelEl.textContent   = STEP_LABELS[n];
      if (stepPctEl)    stepPctEl.textContent      = STEP_PCTS[n];

      /* Scroll card into view on mobile */
      var card = wrapper.querySelector('.kiasa-roi-card');
      if (card && window.innerWidth <= 750) {
        setTimeout(function () {
          card.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
      }
    }

    /* ─────────────────────────────────────────────
       VALIDATION
    ───────────────────────────────────────────── */
    function validateStep(n) {
      var valid = true;

      function checkField(fieldName, errorMsg, customCheck) {
        var input    = wrapper.querySelector('[data-field="' + fieldName + '"]');
        var errorEl  = wrapper.querySelector('[data-error="' + fieldName + '"]');
        var val      = input ? input.value.trim() : '';
        var passed   = val !== '' && (typeof customCheck !== 'function' || customCheck(val));

        if (input) {
          input.classList.toggle('has-error', !passed);
        }
        if (errorEl) {
          errorEl.classList.toggle('is-visible', !passed);
        }
        if (!passed) valid = false;
        return passed;
      }

      if (n === 1) {
        checkField('length', '', function (v) { return parseFloat(v) > 0; });
        checkField('width',  '', function (v) { return parseFloat(v) > 0; });
        checkField('height', '', function (v) { return parseFloat(v) > 0; });
      }

      if (n === 2) {
        checkField('programme', '', function (v) { return v !== ''; });
      }

      if (n === 3) {
        checkField('name',  '', function (v) { return v.length >= 2; });
        checkField('email', '', function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); });

        /* Role pill validation */
        if (!selectedRole) {
          if (pillsError) pillsError.classList.add('is-visible');
          valid = false;
        }
      }

      return valid;
    }

    /* ─────────────────────────────────────────────
       CALCULATIONS
    ───────────────────────────────────────────── */
    function calculate() {
      var length   = parseFloat(wrapper.querySelector('[data-field="length"]').value);
      var width    = parseFloat(wrapper.querySelector('[data-field="width"]').value);
      var height   = parseFloat(wrapper.querySelector('[data-field="height"]').value);

      var programmeEl    = wrapper.querySelector('[data-field="programme"]');
      var programmeLabel = programmeEl
        ? programmeEl.options[programmeEl.selectedIndex].text
        : '';

      var classesPerWeek = parseInt(wrapper.querySelector('[data-field="classes"]').value, 10) || 0;
      var avgCapacity    = parseInt(wrapper.querySelector('[data-field="capacity"]').value, 10) || 0;
      var ticketPrice    = parseFloat(wrapper.querySelector('[data-field="ticket"]').value) || 0;
      var hasClassData   = classesPerWeek > 0 && avgCapacity > 0 && ticketPrice > 0;
      var clientName     = wrapper.querySelector('[data-field="name"]').value.trim();
      var clientEmail    = wrapper.querySelector('[data-field="email"]').value.trim();

      var total_area          = length * width;
      var equipment_cost_min  = total_area * costPerSqm;
      var equipment_cost_max  = total_area * costPerSqmMax;
      var equipment_cost_avg  = (equipment_cost_min + equipment_cost_max) / 2;
      var weekly_revenue      = classesPerWeek * avgCapacity * ticketPrice;
      var monthly_revenue     = weekly_revenue * 4.33;
      var net_monthly         = monthly_revenue - 1200 - (equipment_cost_avg / 60);
      var annual_revenue      = weekly_revenue * 52;
      var net_monthly_no_amort = monthly_revenue - 1200;
      var payback_weeks        = net_monthly_no_amort > 0
        ? Math.round(equipment_cost_avg / net_monthly_no_amort * 4.33)
        : null;
      var roi_annually        = (net_monthly * 12 / equipment_cost_avg) * 100;

      results = {
        length            : length,
        width             : width,
        height            : height,
        total_area        : total_area,
        programme         : programmeLabel,
        classes_per_week  : classesPerWeek,
        avg_capacity      : avgCapacity,
        ticket_price      : ticketPrice,
        name              : clientName,
        email             : clientEmail,
        role              : selectedRole,
        equipment_cost_min: equipment_cost_min,
        equipment_cost_max: equipment_cost_max,
        equipment_cost_avg: equipment_cost_avg,
        net_monthly       : net_monthly,
        monthly_revenue   : monthly_revenue,
        annual_revenue    : annual_revenue,
        payback_weeks     : payback_weeks,
        roi_annually      : roi_annually,
        currency          : currency,
        has_class_data    : hasClassData
      };

      return results;
    }

    /* ─────────────────────────────────────────────
       RENDER RESULTS (Step 4)
    ───────────────────────────────────────────── */
    function fmt(val) {
      return currency + Math.round(val).toLocaleString('en-GB');
    }

    function renderResults(r) {
      function set(attr, val) {
        var el = wrapper.querySelector('[data-result="' + attr + '"]');
        if (el) el.textContent = val;
      }
      var noData = 'Not enough data about your studio';
      set('equipment',      fmt(r.equipment_cost_min) + ' \u2013 ' + fmt(r.equipment_cost_max));
      set('payback',        r.has_class_data ? (r.payback_weeks !== null ? r.payback_weeks + '\u00a0wks' : 'N/A') : noData);
      set('roi',            r.has_class_data ? r.roi_annually.toFixed(1) + '%' : noData);
      set('annual-revenue', r.has_class_data ? fmt(r.annual_revenue) : noData);
    }

    /* ─────────────────────────────────────────────
       BUTTON EVENT DELEGATION
    ───────────────────────────────────────────── */
    wrapper.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-btn]');
      if (!btn) return;

      var action = btn.dataset.btn;

      if (action === 'next-1') {
        if (validateStep(1)) showStep(2);
        return;
      }

      if (action === 'back-2') {
        showStep(1);
        return;
      }

      if (action === 'next-2') {
        if (validateStep(2)) showStep(3);
        return;
      }

      if (action === 'back-3') {
        showStep(2);
        return;
      }

      if (action === 'show-results') {
        if (!validateStep(3)) return;

        /* Loading state */
        btn.classList.add('is-loading');
        btn.textContent = 'Calculating\u2026';

        var r = calculate();
        renderResults(r);

        sendEmails(r,
          function onDone() {
            btn.classList.remove('is-loading');
            btn.textContent = 'Show results \u2192';
            showStep(4);
            if (emailSuccess) emailSuccess.classList.add('is-visible');
          },
          function onFail() {
            btn.classList.remove('is-loading');
            btn.textContent = 'Show results \u2192';
            showStep(4);
            /* Email failed silently — results still show */
          }
        );
        return;
      }

      if (action === 'download-pdf') {
        generatePDF(results);
        return;
      }
    });

    /* ─────────────────────────────────────────────
       EMAILJS — send both emails
    ───────────────────────────────────────────── */
    function sendEmails(r, onSuccess, onError) {
      if (!window.emailjs || !serviceId || !templateId) {
        if (onSuccess) onSuccess();
        return;
      }

      var today = new Date().toLocaleDateString('en-GB', {
        day: 'numeric', month: 'long', year: 'numeric'
      });
      var now = new Date().toLocaleString('en-GB');

      var clientParams = {
        to_email        : r.email,
        to_name         : r.name,
        studio_dimensions: r.length + 'm \u00d7 ' + r.width + 'm',
        total_area      : r.total_area.toFixed(1) + ' m\u00b2',
        ceiling_height  : r.height + 'm',
        programme       : r.programme,
        equipment_cost  : currency + Math.round(r.equipment_cost_min).toLocaleString('en-GB') + ' \u2013 ' + currency + Math.round(r.equipment_cost_max).toLocaleString('en-GB'),
        net_monthly     : currency + Math.round(r.net_monthly).toLocaleString('en-GB'),
        payback         : r.payback_weeks !== null ? r.payback_weeks + ' weeks' : 'N/A',
        annual_revenue  : currency + Math.round(r.annual_revenue).toLocaleString('en-GB'),
        roi_annually    : r.roi_annually.toFixed(1) + '%',
        subject         : 'Your KIASA studio ROI report'
      };

      var teamParams = {
        to_email          : teamEmail,
        to_name           : 'KIASA team',
        client_name       : r.name,
        client_email      : r.email,
        client_role       : r.role,
        studio_dimensions : r.length + 'm \u00d7 ' + r.width + 'm',
        total_area        : r.total_area.toFixed(1) + ' m\u00b2',
        ceiling_height    : r.height + 'm',
        programme         : r.programme,
        equipment_cost    : currency + Math.round(r.equipment_cost_min).toLocaleString('en-GB') + ' \u2013 ' + currency + Math.round(r.equipment_cost_max).toLocaleString('en-GB'),
        net_monthly       : currency + Math.round(r.net_monthly).toLocaleString('en-GB'),
        payback           : r.payback_weeks !== null ? r.payback_weeks + ' weeks' : 'N/A',
        annual_revenue    : currency + Math.round(r.annual_revenue).toLocaleString('en-GB'),
        roi_annually      : r.roi_annually.toFixed(1) + '%',
        submission_date   : now,
        subject           : 'New ROI calculation \u2014 ' + r.name
      };

      var sends = [window.emailjs.send(serviceId, templateId, clientParams)];
      if (teamEmail) {
        sends.push(window.emailjs.send(serviceId, templateId, teamParams));
      }

      Promise.all(sends)
        .then(function () { if (onSuccess) onSuccess(); })
        .catch(function (err) {
          console.warn('KIASA EmailJS error:', err);
          if (onError) onError();
        });
    }

    /* ─────────────────────────────────────────────
       jsPDF — generate and download PDF report
    ───────────────────────────────────────────── */
    function generatePDF(r) {
      if (!window.jspdf || !window.jspdf.jsPDF) {
        alert('PDF generator is still loading. Please wait a moment and try again.');
        return;
      }

      var jsPDF  = window.jspdf.jsPDF;
      var doc    = new jsPDF({ unit: 'mm', format: 'a4' });
      var pageW  = doc.internal.pageSize.getWidth();
      var pageH  = doc.internal.pageSize.getHeight();
      var margin = 20;
      var colMid = pageW / 2;

      var todayLong  = new Date().toLocaleDateString('en-GB', {
        day: 'numeric', month: 'long', year: 'numeric'
      });
      var dateShort      = new Date().toISOString().slice(0, 10);
      var safeClientName = (r.name || 'client').replace(/[^a-zA-Z0-9]/g, '-');

      /* ── Header bar ── */
      doc.setFillColor(249, 115, 22); /* #F97316 */
      doc.rect(0, 0, pageW, 22, 'F');

      if (logoCache && logoCache.src) {
        /* Scale logo to 13mm tall, centred vertically in the 22mm bar */
        var logoH = 13;
        var logoW = logoH * (logoCache.w / logoCache.h);
        var logoX = (pageW - logoW) / 2;
        var logoY = (22 - logoH) / 2;
        doc.addImage(logoCache.src, 'PNG', logoX, logoY, logoW, logoH);
      } else {
        /* Fallback: plain text if logo hasn't loaded */
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(22);
        doc.setFont('helvetica', 'bold');
        doc.text('KIASA', colMid, 14, { align: 'center' });
      }

      /* ── Title ── */
      doc.setTextColor(26, 35, 50);
      doc.setFontSize(18);
      doc.setFont('helvetica', 'bold');
      doc.text('ROI projection report', margin, 36);

      /* ── Subtitle ── */
      doc.setTextColor(100, 116, 139);
      doc.setFontSize(11);
      doc.setFont('helvetica', 'normal');
      doc.text(r.name + '     |     Generated: ' + todayLong, margin, 44);

      /* ── Orange divider ── */
      doc.setDrawColor(249, 115, 22);
      doc.setLineWidth(0.7);
      doc.line(margin, 49, pageW - margin, 49);

      var y = 60;

      /* ── Section: Your studio ── */
      doc.setTextColor(26, 35, 50);
      doc.setFontSize(13);
      doc.setFont('helvetica', 'bold');
      doc.text('Your studio', margin, y);
      y += 9;

      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(100, 116, 139);

      var studioLines = [
        'Dimensions: ' + r.length + 'm \u00d7 ' + r.width + 'm',
        'Total area: ' + r.total_area.toFixed(1) + ' m\u00b2',
        'Ceiling height: ' + r.height + 'm',
        'Programme: ' + r.programme
      ];
      studioLines.forEach(function (line) {
        doc.text(line, margin, y);
        y += 6;
      });

      y += 8;

      /* ── Section: Financial projections ── */
      doc.setTextColor(26, 35, 50);
      doc.setFontSize(13);
      doc.setFont('helvetica', 'bold');
      doc.text('Financial projections', margin, y);
      y += 11;

      var noDataPdf = 'Not enough information about your studio';

      /* Row 1: Equipment — full width */
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(100, 116, 139);
      doc.text('Equipment cost', margin, y);
      y += 6;

      doc.setFontSize(15);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(26, 35, 50);
      doc.text(
        currency + Math.round(r.equipment_cost_min).toLocaleString('en-GB') + ' \u2013 ' + currency + Math.round(r.equipment_cost_max).toLocaleString('en-GB'),
        margin, y
      );
      y += 12;

      /* Row 2: Payback + ROI */
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(100, 116, 139);
      doc.text('Payback period', margin, y);
      doc.text('Annual ROI', colMid + 5, y);
      y += 6;

      if (r.has_class_data) {
        doc.setFontSize(15);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(26, 35, 50);
        doc.text(r.payback_weeks !== null ? r.payback_weeks + ' weeks' : 'N/A', margin, y);
        doc.text(r.roi_annually.toFixed(1) + '%', colMid + 5, y);
      } else {
        doc.setFontSize(9);
        doc.setFont('helvetica', 'italic');
        doc.setTextColor(100, 116, 139);
        doc.text(noDataPdf, margin, y);
      }
      y += 18;

      /* ── Annual revenue highlight box ── */
      var boxH = 26;
      doc.setFillColor(249, 115, 22);
      doc.roundedRect(margin, y, pageW - margin * 2, boxH, 3, 3, 'F');

      doc.setTextColor(255, 255, 255);
      doc.setFontSize(9);
      doc.setFont('helvetica', 'bold');
      doc.text('ESTIMATED ANNUAL REVENUE', colMid, y + 9, { align: 'center' });

      doc.setFontSize(r.has_class_data ? 22 : 10);
      doc.setFont('helvetica', r.has_class_data ? 'bold' : 'italic');
      doc.text(
        r.has_class_data ? currency + Math.round(r.annual_revenue).toLocaleString('en-GB') : noDataPdf,
        colMid, y + 20, { align: 'center' }
      );
      y += boxH + 14;

      /* ── CTA block ── */
      var ctaText = 'Leave a request and receive a full studio specification \u2014 written layout, product recommendation, running cost, and payback calculation \u2014 built around your space.';
      var ctaLink = 'Get your studio specification \u2192';
      var ctaUrl  = 'https://kiasa.co.uk/pages/contact-kiasa-infrared-heating-experts-in-the-uk';

      /* Measure wrapped text height to size the box */
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      var ctaTextW  = pageW - margin * 2 - 10; /* inner width after accent bar + padding */
      var ctaLines  = doc.splitTextToSize(ctaText, ctaTextW);
      var ctaBodyH  = ctaLines.length * 5.5;   /* line height ~5.5mm at 10pt */
      var ctaBoxH   = ctaBodyH + 10 + 8;       /* top/bottom padding + link line */

      /* Light orange fill */
      doc.setFillColor(255, 237, 213); /* ~orange-100 */
      doc.roundedRect(margin, y, pageW - margin * 2, ctaBoxH, 3, 3, 'F');

      /* Left accent bar */
      doc.setFillColor(249, 115, 22);
      doc.rect(margin, y, 3, ctaBoxH, 'F');

      /* Body text */
      doc.setTextColor(26, 35, 50);
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      var ctaTextX = margin + 3 + 7; /* after accent bar + inner padding */
      doc.text(ctaLines, ctaTextX, y + 7, { lineHeightFactor: 1.5 });

      /* Hyperlink line */
      var linkY = y + 7 + ctaBodyH + 3;
      doc.setTextColor(249, 115, 22);
      doc.setFont('helvetica', 'bold');

      /* Underline manually (jsPDF textWithLink doesn't draw underline) */
      var linkW = doc.getTextWidth(ctaLink);
      doc.setDrawColor(249, 115, 22);
      doc.setLineWidth(0.3);
      doc.line(ctaTextX, linkY + 0.8, ctaTextX + linkW, linkY + 0.8);

      doc.textWithLink(ctaLink, ctaTextX, linkY, { url: ctaUrl });

      y += ctaBoxH + 10;

      /* ── Footer footnote ── */
      doc.setTextColor(148, 163, 184);
      doc.setFontSize(9);
      doc.setFont('helvetica', 'italic');
      doc.text(
        '*Indicative figures based on standard KIASA installation data.',
        margin, pageH - 14
      );

      /* ── Page number ── */
      doc.setFont('helvetica', 'normal');
      doc.text('Page 1', pageW - margin, pageH - 14, { align: 'right' });

      /* ── Save ── */
      doc.save('KIASA-ROI-Report-' + safeClientName + '-' + dateShort + '.pdf');
    }

  } /* end initCalc */

})();
